import { useState, useContext, useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineDelete } from "react-icons/md";

import { AppContext } from "../../../Context";
import { PiStudent, PiPencil, PiBuildingsLight } from "react-icons/pi";
import { MdOutlineArrowLeft, MdOutlineRemoveRedEye, MdModeEdit, MdOutlineCleaningServices } from "react-icons/md";

import Fetch, { Loader, GET, DateToText, SecoundsToTime } from "../../../inc/Fetch"; 
import { ClassesDropdown } from "../../../components/Form"; 
import Task from "./Task"; 
import Permission from '../../Permission'

import './css/Teacher_tasks.css'
import Games from './Games';

export default function Teachers_games_info() {

    const { t } = useTranslation();
    const params = useParams();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [loading, setloading] = useState(false);


    async function loadData() {
        let r = await GET(`games/viewMyGame?_id=${params?.id}`);
        
        return r;
    }


    const { data, error, isLoading, refetch } = useQuery(`viewMyGame_${params?.id}`, loadData); 

    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://teams.microsoft.com/share/launcher.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);
        }
    }, []);
    
    useEffect(() => {
        const script = document.createElement('script');
        
        script.src = "https://apis.google.com/js/platform.js";
        script.async = true;
        script.defer = true;
        
        document.body.appendChild(script);
        
        return () => {
            document.body.removeChild(script);

            window.___gcfg = {
                parsetags: 'onload'
            };
        }
    }, []);

    if (isLoading) {
        return  <Loader />;
    }

    if (userinfo?.userlevel < 3) {
        return <Permission />
    }
    
    
    if (userinfo?._id != data?.game?.user?.val) {
        return <Permission />
    }




    return (
        <div className='teacherTaskBox insideMyTask'>
            <div className='mainWidth shadow' style={{maxWidth:900}}>

                <nav className='breadcrumbs'>
                    <Link to={`/`}>{t("home")}</Link>
                    <MdOutlineArrowLeft />
                    <Link to='/myTasks'>{t("header_user_menu_2")}</Link>
                    <MdOutlineArrowLeft />
                    <Link>{data?.task?.title}</Link>
                
                </nav>


                <Games v={data?.game} onSave={() => refetch()} />
                
                <div className='tasksStatsBox ' >

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[0]}</b>
                            <span>{t("tasks_stats_9")}</span>
                        </p>
                        <PiPencil />
                    </div>
                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[1]}</b>
                            <span>{t("tasks_stats_2")}</span>
                        </p>
                        <PiStudent />
                    </div>

                    <div >
                        <hr />
                        <p>
                            <b>{data?.stats[2]}</b>
                            <span>{t("tasks_stats_7")}</span>
                        </p>
                        <PiStudent />
                    </div>


                </div>

                <div className='myTaskBody' style={{backgroundColor:"#fff"}}>
                            
                    
                    <table className='table'>
                        <thead>
                            <tr>
                                <td style={{width:40}}>#</td>
                                <td className='text-right' >{t("name")}</td>
                                <td style={{width:120}}>{t("game_score")}</td>
                                <td style={{width:120}}>{t("status")}</td>
                                <td style={{width:130}}>{t("tasks_sent_date")}</td>
                                {/* <td style={{width:90}}>{t("task_answer_2")}</td> */}
                            </tr>
                        </thead>

                        {data?.students?.length ? <tbody>
                            {data?.students?.map((v, k) => {
        
                                return (
                                    <tr key={k}>
                                        <td >{k+1}</td>
                                        <td className='text-right'>{v?.name}</td>
                                        <td>{v?.answer?.score ? <span className='tag blue'>{v?.answer?.score}</span> : "--"}</td>
                                        <td><span className={`tag ${v?.answer?.status == 1 && 'orange'} ${v?.answer?.score && 'blue'}`}>{t(`task_student_status_${v?.answer?.score ? '2' : '0'}`)}</span></td>
                                        <td>{v?.answer?.date ? <DateToText time={v?.answer?.date} type='datetime' /> : "--" }</td>
                                        {/* <td>
                                            {v?.answer?.date ? 
                                            <>
                                                <a onClick={() => deleteAnswers(v?._id)} title={t("task_delete_answers")} className='btn red'><MdOutlineCleaningServices /></a>
                                            </>
                                            :
                                                <>
                                                    <a style={{opacity:0.7}} title={t("task_delete_answers")} className='btn gray'><MdOutlineCleaningServices /></a>
                                                </>
                                            }
                                        </td> */}
                                    </tr>
                                )
                            })}
                        </tbody>: false}
                    </table>

                    {!data?.students?.length ? <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>: false}

                </div>

                

            </div>


        </div>
    )
}
